<template>
    <div>
        <b-navbar toggleable="md" type="light">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav fill class="nav-center">
                    <li class="nav-item"><router-link :to="{ name: 'what-we-do' }" class="nav-link">What We Do</router-link></li>
                    <li class="nav-item"><router-link :to="{ name: 'creative-services' }" class="nav-link">Creative Services</router-link></li>
                    <li class="nav-item"><router-link :to="{ name: 'products' }" class="nav-link">Products</router-link></li>
                    <li class="nav-item"><router-link :to="{ name: 'view-our-work' }" class="nav-link">View Our Work</router-link></li>
                    <li class="nav-item"><router-link :to="{ name: 'estimate' }" class="nav-link">Create an Estimate</router-link></li>
                    <li class="nav-item"><router-link :to="{ name: 'contact-us' }" class="nav-link">Contact Us</router-link></li>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },

    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue